<template>
  <div>
    <h1>Review sites</h1>
    <v-btn :to="{ name: 'reviewSiteAdd' }">
      <v-icon>add</v-icon>Review site
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="reviewSites"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{ name: 'reviewSite', params: { id: props.item.id } }"
              small
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.name }}</td>
          <td>
            <a :href="props.item.url" target="_blank">{{ props.item.url }}</a>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ReviewSites",
  metaInfo() {
    return {
      title: "Review sites",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      reviewSites: [],
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Url",
          value: "url"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    async fetchReviewSites() {
      const response = await nbmlaw.get(`/cors/admin/directory/reviewSites`);
      // console.log(response.data);
      this.reviewSites = response.data;
    }
  },
  created() {
    this.fetchReviewSites();
  }
};
</script>
